import { Channel } from '@models/channel';
import { ObjectHelper } from '@utilities/object-helper';

/**
 * This is the measured telemetry data about a specific channel
 */
export class ChannelData extends Channel {
  power: number;
  bandwidth: number;
  mer: number;
  preBER: number;
  postBER: number;
  snr: number;
  portSnr: number;
  rxPwr: number;
  coefficient: string;
  locked: boolean;

  /**
   * Empty constructor is used.  Creating the constructor to indicate it's usage, even though there is no custom logic in the function
   */
  constructor() {
    super();
  }

  static getChannelDataFromHttpResponse(httpResponse: any): ChannelData[] {
    const rows = Array.isArray(httpResponse) ? httpResponse.filter(channel => channel && typeof channel === 'object') : [];
    const channelList: ChannelData[] = ObjectHelper.copyArray(rows, ChannelData);
    channelList.map((channel, index) => {
      channel.frequency = rows[index].freq;
      channel.power = rows[index].power ?? rows[index].pwr;
    });
    return channelList;
  }
}
